export default "__VITE_ASSET__cad31a57__"